import { findIndex } from 'lodash'
import * as CONST from 'Reducers/Roster/const'
import { CLEAR_ALL_FILTERS } from 'Reducers/Filter/const'

const initState = {
  rosterById: {},
  rostersByCityPlanId: [],
  rostersByCityId: [],
  rostersByCityPlanIdStatusFilter: null,
  clientRostersByCities: [],
}

export function rosters(state = initState, action) {
  switch (action.type) {
    case CONST.CLEAR_ROSTER_BY_ID:
      return {
        ...state,
        rosterById: initState.rosterById,
      }

    case CONST.GET_ROSTER_BY_ID_SUCCESS:
      return {
        ...state,
        rosterById: action.payload.rosterById,
      }

    case CONST.CLEAR_ROSTERS_BY_CITY_PLAN_ID:
      return {
        ...state,
        rostersByCityPlanId: initState.rostersByCityPlanId,
      }

    case CONST.GET_ROSTERS_BY_CITY_ID_SUCCESS:
      return {
        ...state,
        rostersByCityId: action.payload.rostersByCityId,
      }

    case CONST.SET_ROSTERS_BY_CITY_PLAN_ID_STATUS_FILTER:
      return {
        ...state,
        rostersByCityPlanIdStatusFilter: action.statusFilter,
      }

    case CONST.UPDATE_ROSTER_SUCCESS:
      return {
        ...state,
        rosterById: action.payload.rosterById,
      }

    case CONST.UPDATE_ROSTERS_MISSION_SUCCESS:
      const { missions } = state.rosterById
      const { id } = action
      let updatedMissions = missions.slice()
      updatedMissions.splice(
        findIndex(updatedMissions, { id }),
        1,
        action.payload,
      )

      return {
        ...state,
        rosterById: {
          ...state.rosterById,
          missions: updatedMissions,
        },
      }

    case CONST.GET_CLIENT_ROSTERS_BY_CITIES_SUCCESS:
      return {
        ...state,
        clientRostersByCities: action.payload.clientRostersByCities,
      }

    case CLEAR_ALL_FILTERS:
      return {
        ...state,
        rostersByCityPlanIdStatusFilter:
          initState.rostersByCityPlanIdStatusFilter,
      }
    default:
      return state
  }
}
